import { Injectable } from "@angular/core";
const consentPreferenceKey = "consentPreference";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  constructor() {}

  setConsentPreference(value) {
    localStorage.setItem(consentPreferenceKey, JSON.stringify(value));
  }

  getConsentPreference(): string {
    return localStorage.getItem(consentPreferenceKey);
  }
}
